import { reject } from "q";
import { put } from "redux-saga/effects";
import http from "../../../utils/config/http";

import {
  successRequestUser,
  failRequestUser,
  setUserOrganization,
} from "../actions";

import { setUserSettings } from "~/pages/User/actions";

import oauth from "~/utils/oauth";
import history from "~/utils/config/history";

export function* requestUser() {
  try {
    let resp = yield http.get("/api/user/me");
    yield put(successRequestUser(resp.data));
    const organizationId = resp.data?.organization?.id;
    resp = yield http.get(`/api/mongo/user/${resp.data?.username}`);
    yield put(setUserSettings(resp.data));
    if (organizationId) {
      resp = yield http.get(`/api/organization/find-by-id/${organizationId}`);
      yield put(setUserOrganization(resp.data));
    }
  } catch (error) {
    console.error("[MongoDB]: Not connected!");
    // oauth.logout();
    history.push("/");
    yield put(failRequestUser());
    reject(error);
  }
}
